var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoContato(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 108,
    viewBox: "0 0 150 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.625 75.75C54.625 77.6507 55.582 79.4736 57.2855 80.8176C58.9889 82.1616 61.2993 82.9167 63.7083 82.9167H118.208L136.375 97.25V39.9167C136.375 38.0159 135.418 36.1931 133.715 34.8491C132.011 33.5051 129.701 32.75 127.292 32.75H63.7083C61.2993 32.75 58.9889 33.5051 57.2855 34.8491C55.582 36.1931 54.625 38.0159 54.625 39.9167V75.75Z",
    stroke: "#23C92A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.375 54.375C95.375 56.2978 94.418 58.1419 92.7145 59.5015C91.0111 60.8612 88.7007 61.625 86.2917 61.625H31.7917L13.625 76.125V18.125C13.625 16.2022 14.582 14.3581 16.2854 12.9985C17.9889 11.6388 20.2993 10.875 22.7083 10.875H86.2917C88.7007 10.875 91.0111 11.6388 92.7145 12.9985C94.418 14.3581 95.375 16.2022 95.375 18.125V54.375Z",
    stroke: "#A5D6A7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoContato);
export default __webpack_public_path__ + "static/media/logo-contato.32d65475ca784710866bda9a27be3533.svg";
export { ForwardRef as ReactComponent };